import React from 'react';
import './CarCatalog.css';
import { Link } from 'react-router-dom';
import { taxis } from '../../data/taxis';

const cars = [
  taxis.find(car => car.slug === 'toyota-camry'),
  taxis.find(car => car.slug === 'toyota-corolla-sedan'),
  taxis.find(car => car.slug === 'toyota-rav4-pro')
].filter(car => car !== undefined);

const CarCatalog = () => {
  return (
    <section className="car-catalog" aria-labelledby="catalog-title">
      <div className="container">
        <h2 id="catalog-title">מוניות נבחרות</h2>
        <div className="cars-grid" role="list" aria-label="רשימת מוניות נבחרות">
          {cars.map((car) => (
            <article key={car.id} className="car-card" role="listitem">
              <img 
                src={car.image} 
                alt={`תמונה של ${car.model} - ${car.title}`} 
                className="car-image" 
              />
              <div className="car-info">
                <h3>{car.model}</h3>
                <p className="price" aria-label={`מחיר: ${car.price.toLocaleString()} שקלים כולל מע"מ`}>
                  ₪{car.price.toLocaleString()} כולל מע"מ
                </p>
                <Link 
                  to={`/cars/${car.slug}`} 
                  className="details-button"
                  aria-label={`לפרטים נוספים על ${car.model}`}
                >
                  לפרטים נוספים
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CarCatalog; 